export default __webpack_public_path__ + "static/media/icon-danger.4cad6c59.svg";